import architecture from '@/assets/images/archi.webp';
import blackHoleLandscape from '@/assets/images/blackhole-landscape.webp';
import blackHolePortrait from '@/assets/images/blackhole-portrait.webp';
import craft from '@/assets/images/atelier.webp';
import portal from '@/assets/images/hero.webp';
import monogram from '@/assets/images/logo3d.webp';
import nebulaPoster from '@/assets/images/nebula-poster.webp';
import perfume from '@/assets/images/perfume.webp';
import watch from '@/assets/images/watch.webp';

export interface MediaAsset {
  readonly src: string;
  readonly width: number;
  readonly height: number;
}

/** Registre des visuels : dimensions réelles pour éviter tout décalage de mise en page. */
export const MEDIA = {
  portal: { src: portal, width: 2400, height: 1029 },
  blackHoleLandscape: { src: blackHoleLandscape, width: 2000, height: 1125 },
  blackHolePortrait: { src: blackHolePortrait, width: 780, height: 1688 },
  architecture: { src: architecture, width: 1200, height: 1500 },
  watch: { src: watch, width: 2000, height: 1493 },
  craft: { src: craft, width: 1400, height: 1045 },
  perfume: { src: perfume, width: 1400, height: 1045 },
  monogram: { src: monogram, width: 1600, height: 905 },
  nebula: { src: nebulaPoster, width: 1600, height: 905 },
} as const satisfies Record<string, MediaAsset>;

export type MediaKey = keyof typeof MEDIA;
